import { useEffect, useRef, useState } from 'react'

/**
 * Custom hook to manage subscriber status for server-side rendering decisions
 * This hook mirrors the server-side subscription check for client-side use
 * @param isSubscriberAtServerSide - Boolean indicating if user is a subscriber (from server-side check)
 * @returns isSubscriber - Boolean indicating if the user is a subscriber
 */
export const useShouldShowAds = (isSubscriberAtServerSide?: boolean): boolean => {
  // Initialize based on the provided value, defaulting to true (show ads) if undefined
  const [shouldShowAds, setShouldShowAds] = useState(
    isSubscriberAtServerSide !== undefined ? !isSubscriberAtServerSide : true
  )
  const hasInitialized = useRef(false)

  useEffect(() => {
    if (hasInitialized.current) return
    hasInitialized.current = true

    // Only update if we have a defined subscriber status
    if (isSubscriberAtServerSide !== undefined) {
      setShouldShowAds(!isSubscriberAtServerSide)
    }
  }, [isSubscriberAtServerSide])

  return shouldShowAds
}
